import { Card, Space, Spin } from 'antd';

import { ControlsCard } from './components/ControlsCard.js';
import { HistoryCard } from './components/HistoryCard.js';
import { CompareCard } from './components/CompareCard.js';
import { ScanResultCard } from './components/ScanResultCard.js';
import { usePublicScans } from './usePublicScans.js';

export function PublicScansPage({ registryUrl }: { registryUrl: string }) {
  const state = usePublicScans(registryUrl);

  return (
    <Space direction="vertical" size={12} style={{ display: 'block' }}>
      {state.messageHolder}
      <ControlsCard
        registryUrl={registryUrl}
        url={state.url}
        normalizedUrl={state.normalizedUrl}
        urlValid={state.urlValid}
        onUrlChange={state.setUrl}
        onRunScan={() => void state.runScan()}
        onLoadHistory={() => void state.loadHistory()}
        onResetResult={state.resetResult}
        readyProxy={state.readyProxy}
        loadingProxy={state.loadingProxy}
        onCheckHealth={() => void state.checkReadyViaRegistry()}
        gpc={state.gpc}
        onGpcChange={state.setGpc}
        captureScreenshot={state.captureScreenshot}
        onCaptureScreenshotChange={state.setCaptureScreenshot}
        captureTrace={state.captureTrace}
        onCaptureTraceChange={state.setCaptureTrace}
        messageApi={state.messageApi}
        error={state.error}
      />

      {state.scanning && (
        <Card>
          <Space align="center">
            <Spin />
            <span>Scanning…</span>
          </Space>
        </Card>
      )}

      {state.result && (
        <ScanResultCard
          result={state.result}
          baseline={state.baseline}
          onBaselineChange={(baseline) => state.setBaseline(baseline)}
          messageApi={state.messageApi}
        />
      )}

      <HistoryCard
        registryUrl={registryUrl}
        history={state.history}
        baseline={state.baseline}
        onBaselineChange={state.setBaseline}
        messageApi={state.messageApi}
      />

      <CompareCard
        compare={state.compare}
        compareLoading={state.compareLoading}
        onRefresh={() => void state.loadCompare()}
        diffOpen={state.diffOpen}
        onDiffOpenChange={state.setDiffOpen}
      />
    </Space>
  );
}
